import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NetworkHistoryPaginatedModel } from '../../Models/Models/Network/NetworkHistoryPaginatedModel';
import { NetworkType } from '../../Constants/Enums/Network/NetworkType';

declare var IS_RUNNING_IN_APP_POOL;

export class NetworkHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(networkId: string, networkType: NetworkType, networkName: string, fcaReference: string, postCode: string, forRemuneration: boolean, maxRow: number, minRow: number): Promise<NetworkHistoryPaginatedModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { networkId: networkId, networkType: networkType, networkName: networkName, fcaReference: fcaReference, postCode: postCode, forRemuneration: forRemuneration, maxRow: maxRow, minRow: minRow }

    return AjaxWrapper.get<NetworkHistoryPaginatedModel, any>(url, data);
  }
}

